const setting = {
  setting: 'Setting',
  adminland: 'Adminland',
};
export default setting;
